import { render, staticRenderFns } from "./characterBottom.vue?vue&type=template&id=16ba4d4a&"
var script = {}
import style0 from "./characterBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports